// Import external
import { Component } from '@angular/core';

@Component({
    selector: 'syn-error-page-404',
    styleUrls: ['error-404.component.scss'],
    templateUrl: 'error-404.component.html'
})

export class Error404Component {
}
